module.exports = __webpack_public_path__ + "static/media/1021367.5bc7387e.jpg";